import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

// Updated: backend returns ALL users without pagination.
// Only append sorting params if explicitly supplied by caller.
export const getUsersAction = createAsyncThunk(
  "users/getUsers",
  async (params, thunkAPI) => {
    try {
      let endpoint = API_ENDPOINTS.USERS.GET_ALL; // plain /admin/users
      if (params && (params.sortBy || params.sortOrder)) {
        const sortBy = params.sortBy || "createdAt";
        const sortOrder = params.sortOrder || "desc";
        endpoint += `?sortBy=${encodeURIComponent(
          sortBy
        )}&sortOrder=${encodeURIComponent(sortOrder)}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getUserByIdAction = createAsyncThunk(
  "users/getUserById",
  async (userId, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.USERS.GET_BY_ID(userId)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const createUserAction = createAsyncThunk(
  "users/createUser",
  async (userData, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.USERS.CREATE,
        userData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateUserAction = createAsyncThunk(
  "users/updateUser",
  async ({ userId, userData }, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.USERS.UPDATE(userId),
        userData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteUserAction = createAsyncThunk(
  "users/deleteUser",
  async (userId, thunkAPI) => {
    try {
      await apiService.delete(API_ENDPOINTS.USERS.DELETE(userId));
      return userId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
